import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'haCaselistSearchpipe'
})
export class HaCaselistSearchpipePipe implements PipeTransform {

  transform(patientData:any[], searchTermCaseList:string): any[] {
    if(!patientData || !searchTermCaseList){
      return patientData;
    }
    return patientData.filter(ad=>
      
      
        ad.caseType.toLowerCase().indexOf(searchTermCaseList.toLowerCase().trim()) !== -1 
     );
  }

}
